import React, { forwardRef } from 'react'
import { ISelectProps, Select } from '../Select'
import { TSelectOpt } from '../Select/SelectTypes'

export const RADIUS_OPTIONS: TSelectOpt[] = [
  { value: 1, label: '+ 1 mi' },
  { value: 25, label: '+ 25 mi' },
  { value: 50, label: '+ 50 mi' },
  { value: 100, label: '+ 100 mi' },
  { value: 150, label: '+ 150 mi' },
  { value: 200, label: '+ 200 mi' },
  { value: 250, label: '+ 250 mi' },
]

export interface ISelectRadiusProps extends Omit<ISelectProps, 'options'> {}

const SelectRadius = forwardRef<HTMLInputElement, ISelectRadiusProps>(({ ...SelectProps }, ref) => {
  return <Select ref={ref} options={RADIUS_OPTIONS} {...SelectProps} />
})

export default SelectRadius
